import { createAuthClient } from "better-auth/react";
import { emailOTPClient } from "better-auth/client/plugins";

export const apiBaseUrl =
  import.meta.env["VITE_API_BASE_URL"] ??
  (import.meta.env.PROD ? "https://api.mybettercircle.com" : "http://127.0.0.1:8790");

export const authClient = createAuthClient({
  baseURL: apiBaseUrl,
  plugins: [emailOTPClient()],
});

export const useAuthSession = () => authClient.useSession();
